// extracted by mini-css-extract-plugin
export default {"root":"styles__root__RVqJk","pinned":"styles__pinned___vUyT","left":"styles__left__RBJuG","right":"styles__right__ldVKa"};